<template>
  <div>
    <d-row
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="payments-list-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Szukana fraza (podstawowe dane klienta, numer zamówienia, podstawowe dane placówki)"
          v-model="filters.search" />
        <validation-provider
          :rules="filters.payment_date_to ? 'required' : ''"
          name="payment_date_from"
          v-slot="{ errors }">
          <date-picker
            valueType="format"
            type="date"
            class="ml-2"
            style="width: 200px;"
            :class="{'invalid-date': errors.length }"
            v-model="filters.payment_date_from"
            :state="errors.length ? 'invalid' : null"
            :placeholder="'Data od'"/>
        </validation-provider>
        <validation-provider
          :rules="filters.payment_date_from ? 'required' : ''"
          name="payment_date_to"
          v-slot="{ errors }">
          <date-picker
            valueType="format"
            class="ml-2"
            type="date"
            :class="{'invalid-date': errors.length }"
            style="width: 200px;"
            v-model="filters.payment_date_to"
            :placeholder="'Data do'"/>
        </validation-provider>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          :disabled="!loaded"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          :disabled="!loaded"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0 rwd-disabled">ID</th>
            <th
              scope="col"
              class="border-0">Data wpłaty</th>
            <th
              scope="col"
              class="border-0">Nr zamówienia/Placówka/Kwota</th>
            <th
              scope="col"
              class="border-0">Klient</th>
            <th
              scope="col"
              class="border-0"
              width="200">Rodzaj</th>
            <th
              scope="col"
              class="border-0"
              width="200">Kwota</th>
            <th
              scope="col"
              class="border-0 text-center"
              width="75">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded && !load_error && payments">
          <tr
            v-for="(payment, index) of payments"
            :key="'user-' + index">
            <td class="align-middle rwd-disabled">
              {{ payment.id }}
            </td>
            <td class="align-middle">
              {{ payment.payment_date }}
            </td>
            <td class="align-middle">
              <ul class="mb-0 pl-3">
                <li
                  class="mb-1"
                  v-for="order in payment.orders"
                  :key="order.order_id">
                  <a
                    href="#"
                    @click.prevent="$router.push('/zamowienia/edycja/' + order.order_id)"
                    class="mr-1">{{ order.order_id }}</a>
                  <span class="text-info"><span
                    class="material-icons"
                  style="font-size: 12px;">store</span> {{ order.shop_name }}</span> - {{ Number(order.amount).toFixed(2) }} zł
                </li>
              </ul>
            </td>
            <td class="align-middle">
              <span class="text-success">{{ payment.customer_name }}</span>
            </td>
            <td class="align-middle">
              {{ getPaymentMethodName(payment.settlement_method) }}
            </td>
            <td class="align-middle">
              {{ Number(payment.amount).toFixed(2) }} zł
            </td>
            <td class="align-middle text-center">
              <d-button
                v-if="payment.can_delete"
                @click.prevent="removePayment(payment)"
                theme="danger">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="payments.length === 0">
            <td
              colspan="7"
              class="text-center">
              Brak rozliczeń do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-if="load_error"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>

      <div
        v-else-if="!loaded"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
    </d-card>

    <pagination
      v-if="loaded && !load_error"
      :meta-data="paginationMetaData"
      :initial-page="currentPage"/>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '@/mixins/HasFilters';
import HasPagination from '@/mixins/HasPagination';
import ListUtils from '../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';
import FilterAutocomplete from '../../components/others/filterAutocomplete.vue';
import DatePicker from 'vue2-datepicker';
import PaymentMethods from '@/data/payments-methods.js';

export default {
  name: 'paymentsList',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    FilterAutocomplete,
    DatePicker,
    'pagination': Pagination
  },
  data () {
    return {
      payments: [],
      loaded: false,
      load_error: false,
      remove_in_progress: false,
      show_payment_module: false,
      downloading: false,
      key_payment_module: 0,
      submitting: {
        remove: false,
      },
      filters: {
        search: '',
        customer_id: '',
        payment_date_from: '',
        payment_date_to: ''
      }
    };
  },
  computed: {
    paymentMethods () {
      return PaymentMethods;
    },
  },
  mounted () {
    this.filters.customer_id = this.$route.params.id;
    this.debouncedLoadFilteredData();
  },
  methods: {
    refresh () {
      this.loadFilteredData();
      this.key_payment_module += 1;
    },
    removePayment ({ id }) {
      this.remove_in_progress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/customers/payments/delete/',
        id,
        successTitle: 'Usunięto Wpłatę',
        successText: 'Wybrana wpłata została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć wybraną wpłatę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie wpłaty nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.remove_in_progress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.remove_in_progress = false;
        }
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {};

      if (this.filters.search !== '') {
        where.search = this.filters.search;
      }
      if (this.filters.customer_id !== '') {
        where.customer_id = this.filters.customer_id;
      }
      if (this.filters.payment_date_from !== '') {
        where.payment_date_from = this.filters.payment_date_from;
      }
      if (this.filters.payment_date_to !== '') {
        where.payment_date_to = this.filters.payment_date_to;
      }

      ListUtils.loadItemsData(this, {
        endpoint: '/customers/payments/items?page=' + this.currentPage,
        listField: 'payments',
        errorKey: 'load_error',
        pagination: true,
        params: {
          where,
          per_page: 2
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.load_error = false;
      this.filters = {
        number: '',
        month: '',
        year: '',
        settlement_method: '',
        customer_id: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      FormUtils.validate(this.$refs['payments-list-filters-form'], () => {
        this.$bus.$emit('pagination-reset');
        this.debouncedLoadFilteredData();
      });
    },
    getPaymentMethodName (methodID) {
      if (!methodID) {
        return '-';
      }

      let methodFound = this.paymentMethods.find(item => item.id === methodID);
      if (!methodFound || !methodFound.name) {
        return '-';
      }

      return methodFound.name;
    }
  }
};
</script>
<style lang="scss">
  .orders-list {
    max-width: 30%;
  }
  .my-collapse {
    position: absolute;
    width: 210px;
    z-index: 100;
    background-color: #fff;
    .rounded {
    }
  }
</style>

